let ResourceCategory = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
    },

    delete: function () {
        $('.delete-resource-category').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/resources/categories/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const resourceCategoryForm = $('#resourceCategoryForm');

        if (resourceCategoryForm.length) {
            let submitBtn = Ladda.create(resourceCategoryForm.find('[type=submit]')[0]);

            resourceCategoryForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/resources/categories/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }

        $('#resourceCategories').on('draw.dt', function () {
            _this.delete();
        });
    },
};

$().ready(function () {
    window.ResourceCategory = ResourceCategory;
    window.ResourceCategory.init();
});
